if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains('quick-view') && item.target.id === "quickview-product-content") {
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
                if (item.target.id === "total-price") {
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                    BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
                }     
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)


}